export default "__VITE_ASSET__Cp4DXAYQ__"